import React from 'react';
import cn from 'classnames';
import { ChatMessage } from '@fluentui-contrib/react-chat';
import { SkeletonItem } from '@fluentui/react-components';
import styles from './ChatMessageSkeleton.module.css';

export const ChatMessageSkeleton: React.FC = () => {
  return (
    <ChatMessage>
      <div
        className={cn(styles.skeletonWrapper, 'flex', 'flex-col', 'gap-1')}
        aria-busy="true"
        aria-label="Loading message"
      >
        <SkeletonItem size={16} />
        <SkeletonItem size={16} />
      </div>
    </ChatMessage>
  );
};
